var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.5C2.84315 1.5 1.5 2.84315 1.5 4.5V7.5C1.5 9.15685 2.84314 10.5 4.5 10.5H19.5C21.1569 10.5 22.5 9.15685 22.5 7.5V4.5C22.5 2.84315 21.1569 1.5 19.5 1.5H4.5ZM4.5 4.5H19.5V7.5H4.5V4.5ZM4.5 13.5C2.84315 13.5 1.5 14.8431 1.5 16.5V19.5C1.5 21.1569 2.84314 22.5 4.5 22.5H19.5C21.1569 22.5 22.5 21.1569 22.5 19.5V16.5C22.5 14.8431 21.1569 13.5 19.5 13.5H4.5ZM4.5 16.5H19.5V19.5H4.5V16.5Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCard);
export default __webpack_public_path__ + "static/media/Toggle-Card.f3aee99b4198b234201c86e6e4286beb.svg";
export { ForwardRef as ReactComponent };